import { useContext, useState, useMemo, useEffect } from "react";
import { LangContext } from "../../context/LangContext";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import useFormatImage from "../../hooks/useFormatImage";
import useViewport from "../../hooks/useViewport";
import { Link } from "react-router-dom";
import "./style.css"
import icon_amazon from '../../assets/img/icon_amazon.png';

function Slider({ images, link, show }) {
    const { isDesktop } = useViewport();
    const { translations } = useContext(LangContext);

    const [counter, setCounter] = useState(0);
    const [imgSize, setImgSize] = useState(null);
    const [largeView, setLargeView] = useState(false);

    const currentImage = useMemo(
        () => images[counter] || null,
        [images, counter]
    );

    useEffect(() => {
        if (!show) return
        if (!largeView || !currentImage) return;

        const img = new Image();
        const src = currentImage[isDesktop ? 'url' : '_url'];

        img.src = src;

        img.onload = () => {
            setImgSize({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        };

    }, [largeView, currentImage, isDesktop, show]);

    const prevSlide = () =>
        setCounter(c => c === 0 ? images.length - 1 : c - 1);

    const nextSlide = () =>
        setCounter(c => c === images.length - 1 ? 0 : c + 1);

    const sliderClass = `slider ${show ? 'slider_cube' : 'slider_rect'}`;

    const imgURL = useFormatImage({ image: currentImage });

    return (
        <div className={sliderClass}>
            <div className="view">
                <i
                    className="img"
                    style={{ backgroundImage: `url('${imgURL}')` }}
                />

                {show &&
                    <button className="btn_show" onClick={() => setLargeView(true)}>
                        -<span>{translations.view}</span>-
                    </button>
                }

                <button className="btn_switch btn_left" onClick={prevSlide}>
                    <FaChevronLeft />
                </button>

                <button className="btn_switch btn_right" onClick={nextSlide}>
                    <FaChevronRight />
                </button>
            </div>

            <div className="panel_slider">
                {images.map((img, idx) =>
                    <button key={idx} onClick={() => setCounter(idx)}>
                        <i
                            className="slide"
                            style={{ backgroundImage: `url('${img._url}')` }}
                        />
                    </button>
                )}
            </div>

            {link &&
                <Link className="link_amazon" to={link}>
                    <img src={icon_amazon} alt="" loading="lazy" />
                </Link>
            }

            {largeView && currentImage &&
                <div className="mdl_illustration">
                    <button className="close_mdl" onClick={() => setLargeView(false)} />

                    <div className="content">
                        <div className="vieww">
                            <i
                                className="img"
                                style={{
                                    backgroundImage: `url('${currentImage[isDesktop ? 'url' : '_url']}')`,
                                    aspectRatio: imgSize ? `${imgSize.width} / ${imgSize.height}` : ''
                                }}
                            />

                            <button className="left_illustration btn_switch" onClick={prevSlide}>
                                <FaChevronLeft />
                            </button>

                            <button className="right_illustration btn_switch" onClick={nextSlide}>
                                <FaChevronRight />
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default Slider;